/** The admin shell's strings, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const shell = pickLocale(ar.shell, en.shell)
